import React, {  } from 'react';
import { IStormDoorModel, StormDoorModel } from '../../../entities-generated/models/storm-door/storm-door-model';
import { ProductDetailDialog } from '../pdct-detail-dialog';
import { ICustomerEnrollmentFormModel } from '../../form-services/customer-enrollment-iface';

interface IStormDoorDetailDialogProps {
  door: IStormDoorModel | undefined;
  measurementRequestDate: Date | null;
  requestMeasurementFormModel: ICustomerEnrollmentFormModel;
  onMeasurementRequestSubmitted: () => void;
  onShowPricingExplanation: () => void;
  onCloseDialog: () => void;
}

export const StormDoorDetailDialog: React.FunctionComponent<IStormDoorDetailDialogProps> = (props) => {
  const { door } = props;

  const d = door ?? new StormDoorModel();
  return (
    <ProductDetailDialog
      showDialog={!!door}
      id={d.id}
      brand={d.brand}
      title={d.description}
      averageRating={d.rating}
      rating={d.productReview}
      keyFeatures={d.sellingPoints}
      imageUrls={d.imageUrls}
      variants={d.textureVariants}
      variantDescriptor={'colors'}
      measurementRequestDate={props.measurementRequestDate}
      requestMeasurementFormModel={props.requestMeasurementFormModel}
      onMeasurementRequestSubmitted={props.onMeasurementRequestSubmitted}
      onShowPricingExplanation={props.onShowPricingExplanation}
      onCloseDialog={props.onCloseDialog}
    />
  );
};